import { BaseEdge, getStraightPath } from 'reactflow';

import { EdgeProps } from '../types';

export default function WorkflowInvisibleEdge({ id, sourceX, sourceY, targetX, targetY }: EdgeProps) {
	const [edgePath] = getStraightPath({
		sourceX,
		sourceY,
		targetX,
		targetY,
	});
	return <BaseEdge id={id} path={edgePath} style={{ visibility: 'hidden' }} />;
}
